import { Divider, IconButton, InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useState } from "react";
import Flex from "../../../../../components/Flex";
// import Input from "../../../../../components/Input";
import Text from "../../../../../components/Text";
import { useDebounce } from "../../../../../hooks/use-debounce";
import { useCommunicationMessages } from "../../../../../queries/patient/use-patient-get-all-sms";
import { useSendSmsToPatient } from "../../../../../queries/patient/use-patient-send-sms-to-patient";
import { useChatPatientsList } from "../../../../../queries/use-chat-patients";
import useFcmSmsEventListener from "../../../../../services/fcm/listeners/FcmSmsEventListener";
import { getErrorSnackbar, getXtenantId } from "../../../../../utils/utils";
import { usePreselectedSmsPatient } from "./hooks/use-preselected-sms-patient";
import { MessageContainer } from "./MessageContainer";
import { MessageSideBar } from "./MessageSideBar";
import selectUserImg from "/default-images/select-user.svg";
import { useSnackbar } from "../../../../../hooks/useSnackbar";

const SmsText = () => {
  const [searchPatient, setSearchPatient, instantSearchKey] =
    useDebounce<string>("");
  const {
    data: allPatients,
    isLoading: tableDataLoading,
    refetch: refetchChatPatientsList,
  } = useChatPatientsList({
    gridSorting: [],
    pagination: { page: 0, pageSize: 50 },
    searchKey: searchPatient,
  });
  const [curUser, setCurUser] = useState<any | null>(null);
  const { mutateAsync: sendMessageToPatient } = useSendSmsToPatient();
  const { data: smsRecords, refetch } = useCommunicationMessages({
    pagination: { page: 0, pageSize: 100 },
    xTENANTID: getXtenantId(),
    patientUuid: curUser?.uuid ?? "",
  });

  usePreselectedSmsPatient({
    patients: allPatients?.data?.content,
    onSelect: setCurUser,
  });

  // const [patientList, setPatientList] = useState(allPatients?.data?.content);

  // const generateRandomColor = () => {
  //   return "#" + ((Math.random() * 0xffffff) << 0).toString(16);
  //   // return `#${Math.floor(Math.random() * 7)}`;
  // };

  // useMemo(() => {
  //   setPatientList((prev) =>
  //     prev?.map((it) => ({
  //       ...it,
  //       patientColor: it?.patientColor ?? generateRandomColor(),
  //     }))
  //   );
  // }, [allPatients?.data?.content]);

  // useMemo(() => {
  //   setCurUser(allPatients?.data?.content[0]);
  // }, [allPatients]);

  /**
   * listen to firebase sms notifications
   * @description an incoming sms lands in two places — the sidebar (preview and
   * unread count) and the thread on screen, so both are refetched. The listener
   * is registered once, but `refetch` is bound to the query observer rather than
   * to a render, so it always reloads the thread of the patient currently
   * selected. With no patient selected the thread query is disabled and there is
   * nothing on screen to refresh.
   */
  useFcmSmsEventListener({
    onSmsNotification: () => {
      refetchChatPatientsList();
      refetch();
    },
    onResetSmsCount: () => refetchChatPatientsList(),
  });
  const showSnackbar = useSnackbar();
  const onSend = async (msg: string, user: any) => {
    if (msg?.trim()) {
      await sendMessageToPatient({
        emailToPatient: {
          description: msg,
          patientUuids: [user.uuid],
        },
        xTENANTID: getXtenantId(),
      }).catch((error) => {
        showSnackbar(getErrorSnackbar(error));
      });
      return await refetch();
    }

    return new Promise(() => {});
  };

  return (
    <Flex height={"100%"} width={"100%"}>
      <Flex p={1.2} gap={1} flexDirection={"column"}>
        <TextField
          placeholder="Search here"
          variant="outlined"
          value={instantSearchKey}
          onChange={(e) => setSearchPatient(e.target.value)}
          // sx={{ flex: 1, minWidth: "200px" }}
          InputProps={{
            sx: {
              "& .MuiInputBase-input": { fontSize: "14px" },
            },
            endAdornment: (
              <InputAdornment position="end">
                <IconButton>
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        <MessageSideBar
          setCurUser={setCurUser}
          selectedUser={curUser}
          isLoading={tableDataLoading}
          allUsers={allPatients?.data?.content}
        />
      </Flex>

      <Divider sx={{ width: "1px", backgroundColor: "gray" }} />

      {curUser ? (
        <MessageContainer
          user={curUser}
          onSend={onSend}
          messages={smsRecords?.data}
        />
      ) : (
        <Flex height={"100%"} width={"100%"}>
          <SelectUserToChatMsg />
        </Flex>
      )}
    </Flex>
  );
};

export default SmsText;

const SelectUserToChatMsg = () => {
  return (
    <Flex
      flexDirection={"column"}
      height={"inherit"}
      width={"inherit"}
      alignItems={"center"}
      justifyContent={"center"}
      gap={2}
    >
      <img src={selectUserImg} alt={"No Message Available"} />
      <Text fontSize={"16px"}>Welcome to the Chat Space!</Text>
      <Text variant="subtitle2" fontSize={"16px"}>
        Start a New Healing Conversation
      </Text>
    </Flex>
  );
};
